import { PartnerType } from './partner';

export interface Organisation {
  id: string;
  name: string;
  logo: string;
  type: PartnerType;
  createdAt: Date;
  updatedAt: Date;
}
